import { useState, useEffect } from "react";
import { useForm } from 'react-hook-form';
import HeaderBar from "../HeaderBar";
import useStateMachineWrapper, { sendState } from "../../helpers/useStateMachineWrapper";
import sleep from "../../helpers/sleep";
import Button from "../Button";
import { signupApi } from "../../Api";
import { withHookFormMask } from "use-mask-input";

const PreSaleNotify = (props) => {
  const {actions, state} = useStateMachineWrapper();

  const [isLoading, setIsLoading] = useState(false);

  const { control, register, handleSubmit, getValues, formState: { errors, isValid, submitCount } } = useForm({
    mode: 'onTouched',
    defaultValues: {
      firstName: state.session.firstName,
      lastName: state.session.lastName,
      phoneNumber: state.session.phoneNumber,
      altPhone: state.session.altPhone,
      email: state.session.email,
      preferredContactMethod: state.session.preferredContactMethod,
      ReceiveSMS: true,
      ReceivePromotionalSMS: true,
    },
  });

  const updateData = (data) => {
    actions.update(data);
  }
  const manuallySubmit = async () => {
    setIsLoading(true);
    handleSubmit(updateData)();

    // handleSubmit isn't promise-based so we need to give a slight delay before proceeding otherwise our page might not update correctly
    await sleep(50);

    let _state = state;
    let {page, ..._session} = _state.session;
    _state.session = _session;
    _state.session = {
      ..._state.session,
      ...getValues(),
    };
    _state.session.submitting = false;
    _state.session.isKeepMeUpdated = true;
    _state.session.payment = 'noautopay';
    await sendState(_state);

    setIsLoading(false);

    return true;
  }
  const _submitForm = async () => {
    const didSubmit = await manuallySubmit();
    if(didSubmit) {
      await submitToApi();
      actions.update({
        isKeepMeUpdated: true,
        payment: 'noautopay',
        page: 'presale-notify-complete'
      });
    }
  };

  const submitToApi = async () => {
    const values = getValues();

    const payload = {
      ...values,
      AddressID: state.session.addressID,
    };
    payload.ReceiveSMS = values.ReceiveSMS ? 1 : 0;
    payload.ReceivePromotionalSMS = values.ReceivePromotionalSMS ? 1 : 0;

    try {
      const response = await signupApi.post('kmu', payload);

      if (response.status === 200 && response.data.id) {
        window.sessionStorage.setItem('sessID', response.data.id);
        window.sessionStorage.setItem('orderID', response.data.orderId ?? response.data.id);
      }

      return response;
    } catch (error) {
      console.error("Error submitting:", error);
      throw error;
    }
  };


  return (<>
        <HeaderBar backPage={'presale'} /*nextPage={'presale-notify-complete'} nextPageLoading={isLoading} nextPageEnabled={isValid} nextPageAction={manuallySubmit}*/>
          <h1>Almost There!</h1>
          <p>Fill out the form below and you'll be one of the first to be contacted<br/>when i3 Fiber is available.</p>
        </HeaderBar>

        <div className="mt-4">
          <form onSubmit={handleSubmit(updateData)} className="grid grid-flow-row-dense grid-cols-2 gap-4">
            <input type="text" placeholder="First name" {...register("firstName", {required: 'First name is required'})} />
            <input type="text" placeholder="Last name" {...register("lastName", {required: 'Last name is required'})} />

            <input type="text" placeholder="Cell Phone Number" {...withHookFormMask(register("phoneNumber", {required: 'Cell phone number is required'}), ['(999) 999-9999'])} />
            <input type="text" placeholder="Email Address" {...register("email", {required: 'Email address is required', pattern: {value: /^\S+@\S+$/i, message: 'Please enter a valid email address'}})} className="" />

            {/*<div className="col-span-2 flex justify-center">
              <select {...register("preferredContactMethod")} className="" >
              <option value="">How should we contact you?</option>
              <option value="email">Email</option>
              <option value="phone">Phone</option>
            </select>
            </div>
*/}
            

            {/*
            <select {...register("interestedSpeed")} className="col-span-2">
              <option value="">What Speed Are You Interested In?</option>
              <option value="1gig">1 GIG</option>
              <option value="500mbps">500 mbps</option>
              <option value="250mbps">250 mbps</option>
            </select>
            */}
            <div className="col-span-full sms-concent-wrap">
              <label className="!text-sm sms-concent">
                <input type="checkbox" {...register("ReceiveSMS", {required: 'Agreement to receive SMS from i3 Broadband is required'})} />
                By providing your cell phone number you agree to receive texts from i3 Broadband, LLC about fiber-based service availability, support and/or billing-related information. It will not be used to market new services to you without your consent.
              </label>

              <label className="!text-sm sms-concent">
                <input type="checkbox" {...register("ReceivePromotionalSMS")} />
                Please text me about new services and products available.
              </label>

            </div>

            <div className="col-span-full">
              <Button id="kmu-form-submit-button" className="sm:inline-block" size="large" color="purple" loading={isLoading} enabled={isValid} onClick={() => {isValid && _submitForm()}}>Submit</Button>

              {Object.keys(errors).length > 0 && (
              <div className="bg-red-50 border-[1px] border-red-100 rounded mt-4 p-4 text-left shadow"><ul>{Object.values(errors).map((v,i)=><li key={i}>{v.message}</li>)}</ul></div>
                  )}
              </div>

          </form>
        </div>

    </>)

};

export default PreSaleNotify;
